import React from 'react';
import { Link } from "react-router-dom";


function PopupFooter(props) {

  const arrowStyle = {
    fontSize: ".7em",
    width: "1.2em",
    marginRight: ".5em",
  }

  return (
      <div className="gp-popup-footer">
        <div className="is-vcentered gp-nav">
          <Link to={props.url || '/'}>
            {props.text || <span>
              <span className="icon" style={arrowStyle}>
                <i className="fas fa-arrow-left"></i>
              </span>
              Retour
            </span> }
          </Link>
        </div>
        <div className="is-vcentered gp-logo">
          <img alt="Greenpeace" src="logo-gp.png"/>
        </div>
      </div>
    )
  }

export default PopupFooter;
